import React, { createContext, useContext, useState, useEffect } from "react";

const LanguageContext = createContext({ lang: "en", toggleLang: () => {} });

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState("en");

  useEffect(() => {
    try {
      const stored = localStorage.getItem("sct_lang");
      if (stored === "hi") setLang("hi");
    } catch (_) {}
  }, []);

  function toggleLang() {
    const next = lang === "en" ? "hi" : "en";
    setLang(next);
    try { localStorage.setItem("sct_lang", next); } catch (_) {}
  }

  return (
    <LanguageContext.Provider value={{ lang, toggleLang }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  return useContext(LanguageContext);
}
